import { gql } from '@apollo/client';

export const VALIDATE_AFFILIATE_CODE = gql`
  query ValidateAffiliateCode($code: String!) {
    validateAffiliateCode(code: $code)
  }
`;

export const TRIGGER_AFFILIATE_CONVERSION = gql`
  mutation TriggerAffiliateConversion($paymentIntentId: String!, $affiliateCode: String!) {
    triggerAffiliateConversion(paymentIntentId: $paymentIntentId, affiliateCode: $affiliateCode) {
      success
      message
    }
  }
`;

export interface AffiliateTrackingResponse {
  success: boolean;
  message?: string;
}